import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// data
import { trackHeaderPromoClicked } from "core/trackEvent.js";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";
import { useModal2 } from "core/Modal2";

// styles
import Link from "core/Link";
import { convertPxToRem } from "frontend/components/helpers";
const OpenModalButtonStyled = styled(Link)`
    height: ${convertPxToRem(30)};
`;

// component
export const OpenModalButton = ({ children, ...rest }) => {
    const { isDarkMode } = useSiteHeader();
    const { showModal } = useModal2();

    return (
        <OpenModalButtonStyled
            onClick={showModal}
            darkMode={isDarkMode}
            data-testid="open-modal-button"
            isButton
            disableVisitedStyle
            onMouseDown={trackHeaderPromoClicked}
            {...rest}
        >
            {children}
        </OpenModalButtonStyled>
    );
};

export default OpenModalButton;

// prop-types
OpenModalButton.propTypes = {
    children: PropTypes.any
};
